<template>
  <v-dialog :value="open" max-width="520" @click:outside="$emit('cancel')">
    <v-card>
      <v-card-title class="headline">Marcar como partida conciliatoria</v-card-title>
      <v-card-text>
        <p>
          {{ details.length === 1 ? "El movimiento queda" : "Los " + details.length + " movimientos quedan" }} registrado(s) en Syscore como
          pendiente(s) en el banco y pasa(n) a la próxima conciliación.
        </p>
        <v-radio-group v-model="motivo" hide-details>
          <v-radio label="Automático según el signo (recomendado)" :value="null"></v-radio>
          <v-radio v-for="m in motivos" :key="m.id" :label="m.name" :value="m.id"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="$emit('cancel')">Cerrar</v-btn>
        <v-btn color="success" text :loading="loading" @click="$emit('accept', motivo)">Marcar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    details: { type: Array, default: () => [] },
    motivos: { type: Array, default: () => [] },
    loading: Boolean,
  },
  data() {
    return { motivo: null };
  },
  watch: {
    open(val) {
      if (val) this.motivo = null;
    },
  },
};
</script>
